import React, { useState, useEffect } from 'react';
import { CancelButton, Space, SubmitButton } from '../../../Res/BaseButton';
import { SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { RespActionList, RespActionEditBat, hardTag_arr, hitType_arr, buntTag_arr, hitTag_arr } from '../../../../../item/MyStat/actionList';
import { api_setPlateRecordActionDetail, api_setPlateRecordActionDetailBat } from '../../../../../api/MyStat/apiPlateRecord';
import moment from 'moment';

export function ActionEditBat({ setIsLoading, mRespActionList, set_Save, set_Close }) {

    const [respActionList, setRespActionList] = useState(new RespActionList({}))
    const [HardTag, set_HardTag] = useState("")
    const [HitType, set_HitType] = useState("")
    const [BuntTag, set_BuntTag] = useState("")
    const [HitTag, set_HitTag] = useState("")
    const [video_timestamp, set_video_timestamp] = useState("")
    const [video_timestamp_date, set_video_timestamp_date] = useState("")

    useEffect(() => {
        if (mRespActionList !== null && respActionList !== mRespActionList) {
            // console.log(mRespActionList)
            setRespActionList(mRespActionList)
        }
    }, [mRespActionList])

    useEffect(() => {
        if (respActionList !== null) {
            set_HardTag(respActionList.get_HardTag())
            set_HitType(respActionList.get_HitType())
            set_BuntTag(respActionList.get_BuntTag())
            set_HitTag(respActionList.get_HitTag())
            set_video_timestamp(moment(respActionList.video_timestamp).format('HH:mm:ss'))
            set_video_timestamp_date(moment(respActionList.video_timestamp).format('YYYY/MM/DD'))
        }
    }, [respActionList])

    function close() {
        set_Close(mRespActionList.record_id, false)
    }

    function save() {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        var mRespActionEditBat = new RespActionEditBat({
            record_id: respActionList.record_id,
            HardTag:HardTag,
            HitType:HitType,
            BuntTag:BuntTag,
            HitTag:HitTag,
            video_timestamp: moment(video_timestamp_date + " " +video_timestamp, 'YYYY/MM/DD hh:mm:ss').valueOf()
        })

        api_setPlateRecordActionDetailBat({
            mRespActionEditBat,
            success: (obj) => {
                setIsLoading(false)
                respActionList.action_detail.bat.HardTag = HardTag
                respActionList.action_detail.bat.HitType = HitType
                respActionList.action_detail.bat.BuntTag = BuntTag
                respActionList.action_detail.bat.HitTag = HitTag
                respActionList.video_timestamp = mRespActionEditBat.video_timestamp
                // console.log(respActionList)
                set_Save(respActionList.record_id, respActionList)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }


    return <>
        <div className="row">
            <div className="col-sm-12">
                <SingleInput title={"轉播影片時間"} val={video_timestamp} action={set_video_timestamp} size={3} />
                <SingleSelect title={"擊球強度"}
                    val={HardTag}
                    attr={hardTag_arr}
                    action={set_HardTag}
                    hasBlank={true}
                    size={3}
                />
                <SingleSelect title={"擊球種類"}
                    val={HitType}
                    attr={hitType_arr}
                    action={set_HitType}
                    hasBlank={true}
                    size={3}
                />
                <SingleSelect title={"觸擊標籤"}
                    val={BuntTag}
                    attr={respActionList.get_buntTag_arr()}
                    action={set_BuntTag}
                    hasBlank={true}
                    size={3}
                />
                <SingleSelect title={"安打標籤"}
                    val={HitTag}
                    attr={hitTag_arr}
                    action={set_HitTag}
                    hasBlank={true}
                    size={3}
                />
                {/* <SingleText title={"轉播影片時間"} val={video_timestamp} size={1} />
            <SingleText title={"進壘座標"} val={respActionList.getClipId()} size={1} /> */}
            </div>
        </div>
        <Space />
        <div className="row">
            <div className="col-sm-12">
                <SingleText title={"小懷主機時間"} val={respActionList.get_PitchTime()} size={3} />
                {/* <SingleText title={"落點座標(演算法)"} val={respActionList.get_KZone()} size={3} /> */}
                <SingleText title={"擊球初速"} val={respActionList.get_ExitVelo()} size={2} />
                <SingleText title={"擊球仰角"} val={respActionList.get_ExitAngle()} size={2} />
                <SingleText title={"擊球方向"} val={respActionList.get_ExitDirect()} size={2} />
            </div>
        </div>
        <div className="hr-line-dashed"></div>
        <div className="row m-t-sm m-t-sm">
            <div className="col-sm-4 col-sm-offset-5">
                <CancelButton name={"關閉"} action={close} />
                <SubmitButton name={"修改"} action={save} />
            </div>
        </div>
    </>
}